<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" id="kt_modal_1">
  <div class="modal-dialog " [ngClass]="{'min-w-lg-550px': data.length>0}">
    <div class="modal-content">
      <div class="modal-body p-3">
            <ng-container *ngIf="data.length >0; else nodata">
        <div  id="kt_carousel_3_carousel" class="carousel carousel-custom slide card w-100 border-0 carousel-dark" data-bs-wrap="false"   data-bs-touch="false">
          <!--begin::Heading-->
          <div class="d-flex align-items-center justify-content-between flex-wrap">
            <!--begin::Label-->
            <span class="fs-4 fw-bold pe-2 text-gray-600">Questionnaire </span>
            <!--end::Label-->
            <!--begin::Carousel Indicators-->
            <div>
              <!-- Carousel Indicators -->
              <ol class="p-0 m-0 carousel-indicators carousel-indicators-dots carousel-indicators-active-primary">
                <li *ngFor="let item of data; let i = index"
                    data-bs-target="#kt_carousel_3_carousel"
                    [attr.data-bs-slide-to]="i"
                    class="ms-1"
                    [class.active]="i === 0"></li>
              </ol>
              <!--end::Carousel Indicators-->
            </div>
            <!--end::Heading-->

            <!--begin::Carousel-->
            <div class="carousel-inner pt-8">
              <div *ngFor="let item of data; let first = first , let ind = index " class="carousel-item" [class.active]="first">

                <ng-container [ngSwitch]="item?.type">
                  <div class="card border-bottom-0">
                    <h3 class="card-title text-center">{{ item.question }}</h3>

                    <div class="card-body row row-cols-auto gy-2 px-2"  [ngClass]="{'flex-column': item.type === 'input'}">
                      <div class="ulClass" *ngFor="let res of item?.reponse , let indice =index">
                        <ng-container *ngSwitchDefault>
                          <a  [ngClass]="res?.check===false ? 'btn-light-primary': 'btn-primary '"
                              [ngStyle]="{'--animation-order': indice}"
                              (click)="toggleCheck(item, res)"
                              class="me-10 liClass btn btn-sm">{{ res.label }}</a>

                        </ng-container>
                        <ng-container *ngSwitchCase="'checkbox'">
                          <div class="form-check liClass"  [ngStyle]="{'--animation-order': indice}">
                            <label class="form-check form-check-custom form-check-solid">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                [checked]="res.value" (change)="toggleCheckbox(res , item)"
                              />
                              <span
                                class="form-check-label fw-semibold"
                                translate
                              > {{res?.label}}</span
                              >
                            </label>

                          </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'input'"  [ngStyle]="{'--animation-order': indice}">
                          <div class="fv-row mb-10 liClass">
                            <label class="form-label fw-bold " translate>{{ res.label }}</label
                            ><input
                            class="form-control form-control-lg form-control-solid"  [type]="item.type" [ngModel]="res.value" (ngModelChange)="res.value = $event"
                          />
                          </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'radio'">

                          <div class="me-10 liClass"  [ngStyle]="{'--animation-order': indice}">
                            <div class="form-check form-check-custom form-check-solid">
<!--                              (click)="updateIgnore(item)"-->
                              <input  class="form-check-input"  [name]="'question_' + item.index" type="radio" [value]="res.label" [(ngModel)]="res.check" (click)="radioNext(item)" />
                              <label for="{{ res.label }}" class="form-check-label" >
                                {{ res.label }}
                              </label>
                            </div>
                          </div>

                        </ng-container>
                      </div>
                    </div>
                  </div>

                </ng-container>



              </div>
            </div>

            <!--end::Item-->
          </div>
          <!--end::Carousel-->
          <div class="d-flex justify-content-around">

            <a (click)="prevOrFinish()"  class="btn btn-sm text-hover-primary text-light-primary"  data-bs-target="#kt_carousel_3_carousel" data-bs-slide="prev">
              <!--    <span class="carousel-control-prev-icon" aria-hidden="true">precedent</span>-->
              <span class="fw-bold fs-3" >Précédent</span>
            </a>
              <a *ngIf="!isLastItem()"  (click)="nextOrFinish('ignore')" class="btn btn-sm text-hover-primary text-light-primary"  data-bs-target="#kt_carousel_3_carousel" data-bs-slide="next">
              <!--    <span class="carousel-control-prev-icon" aria-hidden="true"> </span>-->
              <span class="fw-bold fs-3">ignorer la question</span>
            </a>
            <a *ngIf="!isLastItem()" (click)="nextOrFinish()"  class="btn btn-sm text-hover-primary text-light-primary"  data-bs-target="#kt_carousel_3_carousel" data-bs-slide="next">
              <!--    <span class="carousel-control-next-icon" aria-hidden="true">suivant</span>-->
              <span class="fw-bold fs-3" >Suivant</span>
            </a>
            <a (click)="save()" *ngIf="isLastItem()"  [ngClass]="{'pe-none' : checkIfResponsesIgnored()}"  class="btn btn-sm text-hover-primary text-light-primary" >
              <!--    <span class="carousel-control-next-icon" aria-hidden="true">suivant</span>-->
              <span class="fw-bold fs-3"  >terminé</span>
            </a>
          </div>
        </div>
</ng-container>
      </div>
    </div>
  </div>
</div>
<ng-template #nodata>

    <div class="d-flex justify-content-between">
      <div class="shimmerBG title-line "></div>
      <div class="w-25 d-flex justify-content-end">
      <div class="shimmerBG title-line-bis me-1 "></div>
      <div class="shimmerBG title-line-bis me-1 "></div>
      <div class="shimmerBG title-line-bis  me-1"></div>
      </div>
    </div>
    <div class="shimmerBG media"></div>
</ng-template>
